function validMonth(value) {
    return typeof value === 'string' && /^[1-9]\d{3}-(0[1-9]|1[0-2])$/.test(value) ? value : '';
}

function currentMonth(now = new Date()) {
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
}

function shiftMonth(month, delta) {
    if (!validMonth(month)) return '';
    const [year, number] = month.split('-').map(Number);
    const date = new Date(year, number - 1 + delta, 1);
    return validMonth(currentMonth(date));
}

function monthLabel(month) {
    if (!validMonth(month)) return '';
    const names = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
        'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
    return `${names[Number(month.slice(5)) - 1]} ${month.slice(0, 4)}`;
}

function contextKey(user, section) {
    if (!user || !user.company || !user.userId) return null;
    return `argus.workPeriod.v1:${encodeURIComponent(user.company)}:${user.userId}:${section}`;
}

function readContext(storage, user, section) {
    try {
        const key = contextKey(user, section);
        const value = key && storage ? JSON.parse(storage.getItem(key)) : null;
        return value && validMonth(value.month) ? value : {};
    } catch (error) { return {}; }
}

function rememberContext(storage, user, section, value) {
    try {
        const key = contextKey(user, section);
        if (key && storage && validMonth(value.month)) storage.setItem(key, JSON.stringify(value));
    } catch (error) { /* The URL remains sufficient when storage is unavailable. */ }
}

function resolveMonth({sheetMonth, queryMonth, rememberedMonth, section, now}) {
    return validMonth(sheetMonth) || validMonth(queryMonth) || validMonth(rememberedMonth)
        || (section === 'fill' ? currentMonth(now) : shiftMonth(currentMonth(now), -1));
}

module.exports = {validMonth, currentMonth, shiftMonth, monthLabel, contextKey, readContext, rememberContext, resolveMonth};
